import Event from './domain/Event.js';

class Controller {

  constructor(app, factory) {

    this.app = app;
    this.factory = factory;

  }

  initialiseController() {

    this.state = this.app.state;
    this.errorHandler = this.factory.getErrorHandler();
    this.viewBuilder = this.factory.getViewBuilder();
    this.trackingService = this.factory.getTrackingService();
    this.socialIconsLoaderService = this.factory.getSocialIconsLoaderService();

  }

  // Utils

  getState(value) {

    return this.app.state[value];

  }

  setState(state) {

    this.app.setState(state);

  }

  onError(ex) {

    this.errorHandler.bindErrorsToForm(ex);

  }

  startActionInProgress() {

    this.setState({
      actionInProgress: true
    });

  }

  stopActionInProgress() {

    this.setState({
      actionInProgress: false
    });

  }

  // Application Handlers

  handleSuccess(data) {

    this.startActionInProgress();

    this.trackingService.submitEvent(Event.FINAL_STEP_COMPLETED);

    setTimeout(() => {
      this.setState({
        show: false
      });

      if (typeof this.app.state.onSuccess === 'function') {
        this.app.state.onSuccess({jwt: data});
      }
    }, 500);

  }

  handleFailure() {

    this.setState({
      show: false
    });

    if (typeof this.app.state.onFailure === 'function') {
      this.app.state.onFailure();
    }

  }

  handleEmailChange(event) {

    this.setState({emailAddress: event.target.value});

  }

  handlePasswordChange(event) {

    this.setState({password: event.target.value});

  }

  handleRememberMeChange(event) {

    this.setState({rememberMe: event.target.checked});

  }

  // Pages

  showEmailCapturePage() {

    this.trackingService.submitEvent(Event.EMAIL_COLLECTION_FORM_VIEW);
    this.setState({
      view: this.viewBuilder.getCaptureEmailView,
      formError: undefined,
      emailAddressErrorMessage: undefined
    });
    this.socialIconsLoaderService.loadSocialIcons();
    this.stopActionInProgress();

  }

  showBlockedAccountPage() {

    this.setState({
      view: this.viewBuilder.getBlockedMessageView,
      formError: undefined,
      emailAddressErrorMessage: undefined
    });
    this.stopActionInProgress();

  }

  showLockedAccountPage() {

    this.setState({
      view: this.viewBuilder.getLockedMessageView,
      formError: undefined,
      emailAddressErrorMessage: undefined
    });
    this.stopActionInProgress();

  }

  showVerifiedEmailSentPage() {

    this.setState({
      view: this.viewBuilder.getVerifyMessageView,
      formError: undefined,
      emailAddressErrorMessage: undefined
    });
    this.stopActionInProgress();

  }

  showResetPasswordConfirmationPage() {

    this.setState({
      view: this.viewBuilder.getResetPasswordMessageView,
      formError: undefined,
      emailAddressErrorMessage: undefined
    });
    this.stopActionInProgress();

  }

  showLoginPage() {

    this.trackingService.submitEvent(Event.LOGIN_FORM_VIEW);
    this.setState({
      view: this.viewBuilder.getLoginView,
      formError: undefined,
      emailAddressErrorMessage: undefined
    });
    this.stopActionInProgress();

  }

  showLinkAccountRegisterPage() {

    this.setState({
      view: this.viewBuilder.getLinkAccountRegisterView,
      formError: undefined,
      emailAddressErrorMessage: undefined,
      passwordErrorMessage: undefined
    });
    this.stopActionInProgress();

  }

  showLinkAccountPage() {

    this.setState({
      view: this.viewBuilder.getLinkAccountView,
      formError: undefined,
      passwordErrorMessage: undefined
    });
    this.stopActionInProgress();

  }

  // Event Handlers

  processCaptureEmailForm() {

    return submitForm.bind(this)(() => {
      return this.factory.getEmailCaptureHandler().handleSubmit(this.app.state.emailAddress);
    });

  }

  processSocialSignIn() {

    return submitForm.bind(this)(() => {
      return this.factory.getOpenIdLoginHandler().handleSubmit(this.app.state.janrainToken, this.app.state.provider);
    }, this.socialIconsLoaderService.loadSocialIcons.bind(this.socialIconsLoaderService));

  }

  processLoginForm() {

    return submitForm.bind(this)(() => {
      return this.factory.getLoginHandler().handleSubmit(this.app.state.emailAddress, this.app.state.password, this.app.state.rememberMe);
    });

  }

  processResetPasswordForm() {

    return submitForm.bind(this)(() => {
      return this.factory.getResetPasswordHandler().handleSubmit(this.app.state.emailAddress);
    });

  }

  processLinkAccountForm() {

    return submitForm.bind(this)(() => {
      return this.factory.getLinkAccountHandler().handleSubmit(this.app.state.requestToken, this.app.state.emailAddress, this.app.state.password, this.app.state.rememberMe);
    });

  }

  processRegisterForm() {

    return submitForm.bind(this)(() => {
      return this.factory.getRegisterHandler().handleSubmit(this.app.state.requestToken, this.app.state.emailAddress, this.app.state.askForEmailForRegister);
    });

  }

}

let submitForm = function (callback, onErrorExecute) {

  try {

    return callback()
      .catch((ex) => {

        handleFormSubmissionError.bind(this)(ex, onErrorExecute);

      });

  } catch(ex) {

    handleFormSubmissionError.bind(this)(ex, onErrorExecute);

  }

};

let handleFormSubmissionError = function (ex, onErrorExecute) {

  if (typeof onErrorExecute === 'function') {
    onErrorExecute();
  }

  return this.onError(ex);

};

export default Controller;



// WEBPACK FOOTER //
// ./src/library/Controller.js